const onClient = () => typeof window !== 'undefined' && window.location;

export default onClient;
